var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33101 5.69219L2.34195 0.595313C2.29508 0.534375 2.22164 0.5 2.14508 0.5H0.937265C0.832577 0.5 0.774764 0.620312 0.838827 0.701562L4.9857 6L0.838827 11.2984C0.8244 11.3169 0.815448 11.339 0.812995 11.3622C0.810543 11.3855 0.814687 11.409 0.824956 11.43C0.835225 11.4511 0.851203 11.4688 0.871063 11.4811C0.890924 11.4935 0.913865 11.5001 0.937265 11.5H2.14508C2.22164 11.5 2.29508 11.4641 2.34195 11.4047L6.33101 6.30937C6.4732 6.12656 6.4732 5.87344 6.33101 5.69219ZM11.081 5.69219L7.09195 0.595313C7.04508 0.534375 6.97164 0.5 6.89508 0.5H5.68726C5.58258 0.5 5.52476 0.620312 5.58883 0.701562L9.7357 6L5.58883 11.2984C5.5744 11.3169 5.56545 11.339 5.563 11.3622C5.56054 11.3855 5.56469 11.409 5.57496 11.43C5.58522 11.4511 5.6012 11.4688 5.62106 11.4811C5.64092 11.4935 5.66387 11.5001 5.68726 11.5H6.89508C6.97164 11.5 7.04508 11.4641 7.09195 11.4047L11.081 6.30937C11.2232 6.12656 11.2232 5.87344 11.081 5.69219Z",
    fill: "#1F2027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDouble);
export default __webpack_public_path__ + "static/media/arrow-right-double.cc44c2d9e56a84e465f44b0b6269f63c.svg";
export { ForwardRef as ReactComponent };